<template>
  <Card v-if="hours">
    <CardHeader>
      <CardTitle>Hours of Operation</CardTitle>
    </CardHeader>
    <CardContent>
      <ul>
        <li v-for="day in DAYS_OF_WEEK" :key="day">
          <strong>{{ day }}:</strong> {{ getOperatingHours(day) }}
        </li>
      </ul>
    </CardContent>
  </Card>
</template>

<script setup lang="ts">
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

const DAYS_OF_WEEK = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
] as const

type DayOfWeek = (typeof DAYS_OF_WEEK)[number]
type LowercaseDayOfWeek = Lowercase<DayOfWeek>
type Hours = Partial<Record<LowercaseDayOfWeek, string>>

const props = defineProps<{
  hours: Hours | undefined
}>()

function getOperatingHours(day: DayOfWeek): string {
  if (!props.hours) {
    return 'Closed' // Should ideally not happen if v-if="hours" is present, but good practice
  }
  const lowerCaseDay = day.toLowerCase() as LowercaseDayOfWeek
  return props.hours[lowerCaseDay] || 'Closed'
}
</script>
